import Vue from "vue";
import ItineraryDetail from "@/stories/Components/CruiseItineraryDetail/ItineraryDetail";
import store from "@/stories/Components/CruiseItineraryDetail/store";

Vue.component("ItineraryDetail", ItineraryDetail);
const isUsaMarket = window.location.origin.includes("us");
const selector = document.querySelector("[data-itinerary-page]");

if (isUsaMarket && selector) {
  const itineraryEndpoint = selector.getAttribute("data-itinerary-endpoint");
  const langEndpoint = selector.getAttribute("data-labels-endpoint");
  const previewMode = selector.getAttribute("data-preview-mode");
  new Vue({
    el: selector,
    store,
    components: { ItineraryDetail },
    template: `
      <ItineraryDetail
        :itinerary-endpoint="'${itineraryEndpoint}'"
        :labels-endpoint="'${langEndpoint}'"
        :preview-mode="${previewMode}"/>`,
  });
}
